/**
 * Action types for deferred shopper URL generation.
 * These actions are triggered after INIT_PENCIL_SUCCESS when the
 * enableDeferredShopperUrlGeneration feature toggle is enabled.
 */

export const SHOPPER_URLS_REQUEST = 'SHOPPER_URLS_REQUEST';
export const SHOPPER_URLS_SUCCESS = 'SHOPPER_URLS_SUCCESS';
export const SHOPPER_URLS_FAILURE = 'SHOPPER_URLS_FAILURE';
